const FlyApiConfig = {
  forceStubs: false,
  flySearch: {
    useStubs: false,
    cacheName: '',
    serviceName: 'FlySearchRetailService',
    endpoint: '/pws/v0/fly/c/airSearch',
    method: 'POST',
    responseName: 'airSearchRsp',
    timeout: 60000,
    stub: ''
  },
  flyPriceConfirmationExpress: {
    useStubs: false,
    cacheName: '',
    serviceName: 'FlyPriceConfirmationServiceExpress',
    endpoint: '/pws/v1/fly/c/airPrice',
    method: 'GET',
    responseName: 'airPriceRsp',
    timeout: 46000,
    stub: ''
  }
}

export { FlyApiConfig }
